<template>
  <main>
    <div class="main" v-if="videoInfo">
      <dl class="titleTip">
        <dt>
          <span style="color: #666; cursor: pointer" @click="$router.go(-1)"
            >学术讲座 ></span
          >
          <span> 学术讲座详情</span>
        </dt>
        <dd></dd>
      </dl>
      <div class="videoBox" v-show="palyVideo">
        <div class="video">
          <!-- <iframe
            style="width: 100%; height: 520px"
            allowfullscreen="true"
            :src="videoInfo.videoUrl"
            frameborder="0"
            controlslist="nodownload"
          ></iframe> -->
          <video
            controls="controls"
            height="520px"
            width="100%"
            :src="videoInfo.videoUrl"
            type="video/mp4"
            controlslist="nodownload"
            :poster="videoInfo.cover"
          >
            <p>您的浏览器不支持 video 标签。</p>
          </video>
          <!--<video src=""></video>-->
        </div>
      </div>
      <!--<ul class="btns">-->
      <!--<li @click.stop="active = 0" :class="active === 0?'active':''">课程介绍</li>-->
      <!--<li @click.stop="active = 1" :class="active === 1?'active':''">专家介绍</li>-->
      <!--</ul>-->
      <div class="dataBox">
        <div class="boxLeft videoIns" v-show="active === 0">
          <div
            style="
              display: flex;
              font-size: 18px;
              color: #666;
              line-height: 52px;
            "
          >
            <div
              style="padding-right: 60px; cursor: pointer"
              @click.stop="active = 0"
              :class="active === 0 ? 'active' : ''"
            >
              讲座介绍
            </div>
            <div
              style="padding-right: 60px; cursor: pointer"
              @click.stop="active = 1"
              :class="active === 1 ? 'active' : ''"
            >
              嘉宾介绍
            </div>
          </div>
          <!--<div class="title">课程介绍</div>-->
          <!--<div class="videoTime">{{videoIntroduction.time}}</div>-->
          <div style="padding: 15px; border: solid 1px #d3defe">
            <div class="videoTitle">直播概要：</div>
            <div class="videoMaintitle" v-html="videoInfo.videoIntroduce"></div>
          </div>
        </div>
        <div class="boxLeft videoIns" v-show="active === 1">
          <div
            style="
              display: flex;
              font-size: 18px;
              color: #666;
              line-height: 52px;
            "
          >
            <div
              style="padding-right: 60px; cursor: pointer"
              @click.stop="active = 0"
              :class="active === 0 ? 'active' : ''"
            >
              讲座介绍
            </div>
            <div
              style="padding-right: 60px; cursor: pointer"
              @click.stop="active = 1"
              :class="active === 1 ? 'active' : ''"
            >
              嘉宾介绍
            </div>
          </div>
          <div
            class="doctorInsMain"
            style="padding: 15px; border: solid 1px #d3defe"
          >
            <img :src="videoInfo.img" />
            <p>{{ videoInfo.teacherIntroduction }}</p>
          </div>
        </div>
        <dl class="boxRight">
          <dt>
            <p>相关视频</p>
          </dt>
          <dd
            v-for="(item, index) in videoList"
            v-if="index < 2"
            :key="item.videoId"
            @click.stop="toVideosDetailsPage(item.videoId)"
          >
            <img :src="item.img" />
            <div class="leftBox">
              <p class="title">{{ item.name }}</p>
              <p class="name" v-html="item.author"></p>
              <p class="organization" v-html="item.organization"></p>
              <p class="date">{{ item.time }}</p>
            </div>
          </dd>
        </dl>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "Videos",
  components: {},
  created() {
    this.videoId = this.$route.query.videoId;
    this.getVideoDataByVideoId();
  },
  mounted() {
    let video = document.getElementsByTagName("iframe");
    console.log(video);
    // video.controlslist = "nodownload";
  },
  data() {
    return {
      videoId: "",
      videoSrc: "",
      palyVideo: true,
      active: 0,
      videoDetails: {}, // 课程详情
      videoIntroduction: {}, // 课程介绍
      expertIntroduction: {}, // 专家介绍
      videoList: [], // 系列目录
      relatedVideos: [], // 相关课程
      videoInfo: null,
    };
  },
  methods: {
    getVideoDataByVideoId() {
      this.$api.getVideos().then((r) => {
        if (r.code === 1) {
          let arr = [];
          let o = r.data.find((v) => {
            return v.videoId == this.videoId;
          });
          r.data.forEach((v) => {
            if (v.videoId != this.videoId && arr.length <= 3) {
              arr.push(v);
            }
          });
          if (o) {
            this.videoList = arr;
            this.videoInfo = o;
          } else {
            alert("找不到对应的视频资料");
            this.$router.go(-1);
          }
          // this.countNumber = r.data.countNumber;
          // this.videoList = r.data.data;
        } else {
          console.error(r.message);
        }
      });
      // this.$api.getVideoDataByVideoId(params).then(r => {
      //     if (r.code === 1) {
      //       console.log(r)
      //         this.videoDetails = r.data.videoDetails;
      //         this.videoSrc = r.data.videoDetails.src;
      //         this.videoIntroduction = r.data.videoIntroduction;
      //         this.expertIntroduction = r.data.expertIntroduction;
      //         this.videoList = r.data.videoList;
      //         this.relatedVideos = r.data.relatedVideos;
      //     }
      // })
    },
    changeVideo(src) {
      this.videoSrc = src;
      this.palyVideo = true;
    },
    toTeachingVideoPage() {
      let newpage = this.$router.resolve({
        path: "/teachingvideo",
      });
      window.open(newpage.href, "_blank");
    },
    toVideosDetailsPage(id) {
      let newpage = this.$router.resolve({
        path: "/teachingvideo/videos?videoId=" + id,
      });
      // this.$router.push({
      //   path: '/teachingvideo/videos?videoId='+id,
      // })
      window.location.href = newpage.href;
      // window.open(newpage.href, '_blank');
    },
  },
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "./Videos.scss";
</style>
